module.exports = __webpack_public_path__ + "static/media/play02.ef9ffa0e.svg";